<template>
  <div>
    <!-- Quotation Summary Section Start -->
    <!-- {{ QT_modal_show }} -->

    <b-button
      style="font-size: 0.675rem ;margin-left: 5px"
      @click="showQuotationMOdal()"
      size="sm"
      class="mt-1"
      variant="outline-primary"
      >Show Quotation</b-button
    >
    <b-modal
      v-if="QT_fk_all_module_id"
      id="QuptationSummary-modalId"
      ref="QuptationSummary-modal"
      :title="'Quotation Summary - ' + QT_jb_series"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
    <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <div class="row">
        <div class="col-md-4"> <b-button
            v-if="
              mainExecutionDetails.length > 0 &&
              mainExecutionDetails[0].finalBillingCompleted == '0'
            "
            size="sm"
            variant="outline-dark"
            @click="showQuotation"
            class="pull-right"
            >Show Quotation</b-button
          ></div>
        <div class="col-md-4"></div>
        <div class="col-md-4"></div>
          <div class="col-md-12">
          <div
            class="box-body gutr"
            v-if="tptTableData.length > 0 && setShowQuotation == true"
          >
            <div class="box-header">
              <b-button
                v-if="tempffTableArry.length > 0"
                :variant="
                  tptTableArryType == 'FF' ? 'success' : 'outline-success'
                "
                @click="setQuotationType('FF')"
              >
                FF
              </b-button>
              <b-button
                v-if="ccTableArry.length > 0"
                :variant="
                  tptTableArryType == 'CC' ? 'success' : 'outline-success'
                "
                @click="setQuotationType('CC')"
              >
                CC
              </b-button>
              <b-button
                v-if="tptTableData.length > 0"
                :variant="
                  tptTableArryType == 'TPT' ? 'success' : 'outline-success'
                "
                @click="setQuotationType('TPT')"
              >
                TPT
              </b-button>
            </div>
            <!-- /.box-body -->
          </div>
          <div
            class="box-body gutr"
            v-if="tptTableData.length > 0 && setShowQuotation == true"
          >
          <!-- {{tptModal.shipmentType}} -->
            <table
              id="tpt"
              class="table table-bordered"
              v-if="tptTableArryType == 'TPT'"
            >
              <thead>
                <tr>
                  <th>SN.</th>
                  
                  <th>Container Type</th>
                  <!-- <th v-if="tptModal.shipmentType == '1'">Container Type</th> -->
                  <th>Particulars</th>

                  <th>Buy In Rate</th>
                  <th>Selling Rate</th>
                  <th>Unit</th>
                  <th>Validity Date</th>
                  <th>Remarks</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in tptTableData" :key="index">
                  <td>{{ index + 1 }}</td>
                  <!-- <td v-if="tptModal.shipmentType == '1'">
                    {{ item1.containerType }}
                  </td> -->
                  <td>
                    {{ item1.containerType }}
                  </td>
                  <td>{{ item1.otherCharge }}</td>
                  <td>{{ item1.byInPrice }} {{ item1.currency }}</td>
                  <td>{{ item1.qRate }} {{ item1.currency }}</td>
                  <td>
                    {{ item1.unitName ? item1.unitName : "NA" }}
                  </td>
                  <td>{{ item1.validityDate }}</td>

                  <td>{{ item1.remark }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="box-body gutr"
            v-if="ccTableArry.length > 0 && setShowQuotation == true"
          >
            <!-- <div class="box-header">
              <h5 class="box-title">Existing CC Quotation</h5>
                    </div>-->
            <table
              id="cc"
              class="table table-bordered"
              v-if="tptTableArryType == 'CC'"
            >
              <thead>
                <tr>
                  <th>SN</th>

                  <th v-if="enquiryData.shipmentType == '1'">Container Type</th>
                  <th>Particulars</th>
                  <th>Buy In Rate</th>
                  <th>Selling Rate</th>
                  <th>Validity Date</th>
                  <th>Unit</th>

                  <!-- <th>Client Name</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in ccTableArry" :key="index">
                  <td>{{ index + 1 }}</td>

                  <td v-if="enquiryData.shipmentType == '1'">
                    {{ item1.containerType }}
                  </td>
                  <td>{{ item1.ccType }}</td>
                  <td>{{ item1.ccBuyingRate }} {{ item1.currency }}</td>
                  <td>{{ item1.ccSellingRate }} {{ item1.currency }}</td>
                  <td>{{ item1.validityDate }}</td>

                  <td>
                    {{ item1.unitName ? item1.unitName : "NA" }}
                  </td>
                  <!-- <td>{{item1.clientName}}</td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="box-body gutr"
            v-if="tempffTableArry.length > 0 && setShowQuotation == true"
          >
            <table
              id="ff"
              class="table table-bordered"
              v-if="tptTableArryType == 'FF'"
            >
              <thead>
                <tr>
                  <th>SN.</th>
                  <th
                    v-if="
                      enquiryData.shipmentType == 1 &&
                      enquiryData.fclOrlcl == 'lcl'
                    "
                  >
                    Co-Loader
                  </th>
                  <th v-else-if="enquiryData.shipmentType == 1">
                    Shipping Line
                  </th>
                  <th v-else>Airline Name</th>
                  <th v-if="shipmentType == '1'">Container Type</th>
                  <th>Particulars</th>

                  <th>Buying Rate</th>
                  <th>Selling Rate</th>
                  <th>Quotation Validity Till</th>
                  <th>Validity Date</th>
                  <th>Unit</th>

                  <!-- <th>Client Name</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item1, index) in tempffTableArry" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td
                    v-if="
                      enquiryData.shipmentType == '1' &&
                      enquiryData.fclOrlcl == 'lcl'
                    "
                  >
                    {{ item1.coLoaderName }}
                  </td>
                  <td v-else-if="enquiryData.shipmentType == '1'">
                    {{ item1.shippingLine }}
                  </td>
                  <td v-else>{{ item1.airlineName }}</td>
                  <td v-if="enquiryData.shipmentType == '1'">
                    {{ item1.containerType }}
                  </td>
                  <td>{{ item1.ffType }}</td>

                  <td>{{ item1.buyingRate }} {{ item1.currency }}</td>
                  <td>{{ item1.ffSellingRate }} {{ item1.currency }}</td>
                  <td>
                    {{
                      item1.quotationTill == 1
                        ? "Validity Till Handover"
                        : "Validity Till Sailing"
                    }}
                  </td>
                  <td>
                    {{ item1.ffvalidityDate }}
                  </td>
                  <td>
                    {{ item1.unitName ? item1.unitName : "NA" }}
                  </td>
                  <!-- <td>{{item1.clientName}}</td> -->
                </tr>
              </tbody>
            </table>

            <!-- /.box-body -->
          </div>
          <div class="box" v-if="billingTableData.length > 0">
            <!-- /.box-header v-if="showMoreNewItem==false"-->
            <div class="box-body" v-if="showMoreNewItem == true">
              <!-- <label class="box-title">
                  <u>Existing Billing Details</u>
                </label>-->
              <table id="ffContainer" class="table table-bordered">
                <tbody>
                  <tr>
                    <th>#</th>
                    <th>Tally Invoice No.</th>
                    <th>Client Name</th>
                    <th>Job Type</th>
                    <th>Tally Status</th>
                    <th>Added In Tally</th>
                    <th>Date & Details</th>
                    <th>PDF</th>
                  </tr>
                  <tr
                    :style="
                      item1.TallyResponse == ''
                        ? 'color:red'
                        : item1.LINEERROR == '' && item1.CREATED != '0'
                        ? 'color:green '
                        : 'color:red'
                    "
                    v-for="(item1, index) in billingTableData"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td
                      :style="
                        item1.TallyResponse == ''
                          ? 'color:red'
                          : item1.LINEERROR == '' && item1.CREATED != '0'
                          ? 'color:green '
                          : 'color:red'
                      "
                      class="showMoreData"
                      @click="getBillData(item1)"
                    >
                      {{ item1.BillingSeries }}
                    </td>
                    <td>
                      {{ item1.clientName }}
                      <br />
                      <b-badge v-if="item1.invoiceForClient == '2'"
                        >Overseas Agent</b-badge
                      >
                    </td>
                    <td>{{ item1.jobType }}</td>
                    <td>
                      {{
                        item1.TallyResponse == ""
                          ? "Failed To connect to Tally"
                          : item1.LINEERROR == "" && item1.CREATED != "0"
                          ? "DATA ADDED SUCCESSFULLY IN TALLY "
                          : item1.LINEERROR
                      }}
                    </td>
                    <td>
                      <md-icon
                        :style="
                          item1.TallyResponse == ''
                            ? 'color:red'
                            : item1.LINEERROR == '' && item1.CREATED != '0'
                            ? 'color:green '
                            : 'color:red'
                        "
                        class="md-size md-accent"
                        >{{
                          item1.TallyResponse == ""
                            ? "clear"
                            : item1.LINEERROR == "" && item1.CREATED != "0"
                            ? "done_outline"
                            : "clear"
                        }}</md-icon
                      >
                    </td>

                    <td>
                      On {{ item1.loginTime }}
                      <br />
                      By {{ item1.employeeName }}
                      <br />
                      At {{ item1.billingLocationName }}
                    </td>

                    <td>
                      <a
                        v-if="item1.dataPdf"
                        :href="`${docURL}/TALLY_PDF/` + item1.dataPdf"
                        target="_blank"
                        download
                        >View PDF</a
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- /.box-body -->
          </div>
        </div>
      </div>
      <b-button
        @click="showQuotationMOdal()"
        variant="danger"
        class="pull-right"
      >
        Close</b-button
      >
    </b-modal>
    <!-- Quotation Summary Section End -->
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";

export default {
  props: [
    "QT_job_type",
    "QT_fk_all_module_id",
    "QT_jb_series",
    "QT_modal_show",
  ],
  updated() {
    // if (this.QT_fk_all_module_id != "") {
    //   // if (this.QT_modal_show && this.QT_fk_all_module_id != "") {
    //   this.$refs["QuptationSummary-modal"].show();
    //   this.getData();
    // } else {
    //   this.$refs["QuptationSummary-modal"].hide();
    // }
  },
  beforeMount() {
    console.log(this.QT_modal_show);
    if (this.QT_fk_all_module_id != "") {
      //  if (this.QT_modal_show && this.QT_fk_all_module_id != "") {
      // this.getData();
      //  this.getData();
    }
  },
  mounted() {},

  data() {
    return {
      all_module_id: this.QT_fk_all_module_id,
      isCheckAll: false,
      totFinalPartAmount: "0",
      closingReason: "",
      incompleteJobBill: "",
      tempffTableArry: [],
      tptTableData: [],
      ccTableArry: [],
      enquiryData: {
        shipmentType: "",
        fclOrlcl: "",
      },
      setShowQuotation: false,
      tptTableArryType: "FF",
      tptModal: {},
      classId: "",
      billingLocationData: [],
      confirm: {
        title: "Confirmation..!",
        contentHtml: "Data",
        ok: "Send",
        cancel: "Cancel",
      },
      invoiceStatusList: [
        {
          inv: "0",
          int: "In-Complete",
        },
        {
          inv: "1",
          int: "Completed",
        },
      ],
      splitOrMergeConNo: "",
      showMoreNewItem: true,
      selectedTallyInv: "",
      selectedAllModuleId: "",
      showBill: false,
      ccInvoiceTallyData: [],
      miscInvoiceTallyData: [],
      tallyTableData: [],
      validateTally: false,
      unitList: [],
      docURL: URL_BASE_DOC,
      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR",
        },
        {
          currencyV: "USD",
          currencyT: "USD",
        },
        {
          currencyV: "EURO",
          currencyT: "EURO",
        },
        {
          currencyV: "GBP",
          currencyT: "GBP",
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR",
        },
        {
          currencyV: "CAD",
          currencyT: "CAD",
        },
        {
          currencyV: "JOD",
          currencyT: "JOD",
        },
        {
          currencyV: "AED",
          currencyT: "AED",
        },
      ],

      isLoading: false,
      containerNoName: [],
      TPTInvoiceTallyData: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      CCCheckDone: 0,
      ffCheckDone: 0,
      TPTCheckDone: 0,
      miscCheckDone: 0,
      yardCheckDone: 0,
      ibCheckDone: 0,
      ledgerData: [],
      clientData: [],
      TPTGRNDATA: [],
      otherExpenseData: [],
      otherAdditionalTask_Data: [],
      SlinePayment_Data: [],
      ExpenseDoc_Data: [],
      TPTGRNID: [],
      TPTMERGECONTAINERCHARGEID: [],

      TOLLPRICE: "",
      shipmentType: "",
      billingTableData: [],
      containerMasterData: [],
      mainExecutionDetails: [],
      jobTypeSelectVal: false,
      showSegmentArray: [],
      currencyTypeList: [
        {
          type: "USD",
          val: "1",
        },
        {
          type: "INR",
          val: "2",
        },
      ],
      clientTypeList: [
        {
          inv: "1",
          int: "Client",
        },
        {
          inv: "2",
          int: "Oversea Agent",
        },
         {
          type: "Consignee",
          val: "4",
        },
      ],
      cTypeList: [
        {
          inv: "1",
          int: "Client",
        },
      ],
      overTypeList: [
        {
          inv: "2",
          int: "Oversea Agent",
        },
      ],
      showOverSea: false,
      selectedValue: "",
      clist: false,
      slectedAllStatus: "0",
      otherClientChecked: false,
      ffInvoiceModal: {
        splitFromId: "",
        fromAgentColoderTable: "N",
        manualBilling: "0",
        tallyBillingSeries: 1,
        billingStatus: "0",
        invoiceForClient: "",
        acutalclientForOverSea: "",
        otherChargeFF: "",
        BILLDONE: [],
        FFtallyId: [],
        billingLocationId: "",
        billingLocationName: "",
        shipperInvNoforTally: "",
        shipperInvDateforTally: "",
        shipperInvNo: "",
        shipperInvDate: "",
        stateName: "",
        clientgst: "",
        TOLCHRG: "",
        TPTCHARGES: "",
        secondFF: "",
        multiTPT: "",
        grnNo: "",
        pickup: "",
        Handover: "",
        factoryLoc: "",

        jobType: [],
        jobTypeName: [],
        chnageApprovalStatus: "",
        billingId: "",
        invDate: "",
        jobNo: "",
        sentForRevisedApproval: "",
        revisedActionTakenFromMail: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        allModuleId: "",
        ccTypeExImp: "",
        PortAdditionalCharges: "",
        totalAmount: "",
        weight: "",
        vessel: "",
        blNo: "",
        masterBlNo: "",
        houseBlNo: "",
        BOE: "",
        clientId: "",
        clientName: "",
        contact: "",
        adress: "",
        POR: "",
        LP: "",
        POD: "",
        FPOD: "",
        containerDetailsNew: "",
        containerDetailsCC: [],
        containerDetails: [],
        multipleContainerType: "",
        multiConNo: [],
        shippingLine: "",
      },
      newJobType: [],
      disableJobType: [],
      validateInvoice: true,
      ffTallyInvoiceData: [],
      ffInvSummaryData: [],
      ccContainers: [],
      ffContainers: [],
      revisedSavedBillingData: [],
      allContainersDataArray: [],
      splitedOrMergedContainers: [],
      singleSelectContainer: [],
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        // this.getData();
      },
      deep: true,
    },
  },
  methods: {
    showQuotationMOdal() {
      this.showQuotationModal = !this.showQuotationModal;
      this.QuotationSummary();
    },
    QuotationSummary() {
      if (this.showQuotationModal == true && this.QT_fk_all_module_id != "") {
        this.$refs["QuptationSummary-modal"].show();
        this.getData();
      } else {
        // this.showQuotationModal =false;
        this.$refs["QuptationSummary-modal"].hide();
      }
    },
    setQuotationType(type) {
      this.tptTableArryType = type;
      // if(type == 'TPT'){
      //   this.tptTableArry = this.tptTableData;
      // }
      // if(type == 'FF'){
      //   this.tptTableArry = [{
      //   containerType:'FF',
      //   otherCharge:'hh',
      //   byInPrice:'d',
      //   qRate:12,
      //   currency:'INR',
      //   unitName:'NA',
      //   remark:'hello'
      // }]
      // }
      // if(type == 'CC'){
      //   this.tptTableArry = this.ccTableData;
      // }
    },
    showQuotation() {
      console.log("quotation");
      if (this.tempffTableArry.length > 0) {
        this.tptTableArryType = "FF";
      } else if (this.ccTableArry.length > 0) {
        this.tptTableArryType = "CC";
      } else {
        this.tptTableArryType = "TPT";
      }
      this.setShowQuotation = !this.setShowQuotation; 
    },
    linkContainer(item, id, GR, mergeConCharge) {
      this.TPTGRNDATA = [];
      this.TPTMergeConInvoiceTallyData = [];
      this.ffTallyInvoiceData = this.ffTallyInvoiceData.filter(
        (el) => el.color !== "1"
      );
       
      let payload = {};
      if (id == "1") {
        payload = {
          fromSplitMergeAssignId: item.fromSplitMergeAssignId,
          splitedToOrMergedToAssignId: item.splitedToOrMergedToAssignId,
          uniqueContainerId: item.uniqueContainerId,
          containerNo: item.containerNo,
          tptGrnId: item.tptGrnId,
          fetchId: id,
        };
      } else {
        payload = {
          tptGrnId: GR,
          mergeConCharge: mergeConCharge,
          fetchId: id,
          job: this.newJobType,
          getCCSplitChargesId: this.mainExecutionDetails[0].splitFromId,
        };
      }
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/linkContainerForBilling_NewV3.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "sfsfrererere");
            if (data.TPTGRNDATA.length > 0) {
              this.TPTGRNDATA = data.TPTGRNDATA;
              this.TOLLPRICE = parseInt(data.TPTGRNDATA[0].tollPrice);
            } else {
              this.TOLLPRICE = 0;
            }
            if (data.TPTMergeConInvoiceTallyData.length > 0) {
              console.log("tptacois");
              let TPTParti = [];
              let TPTCon = [];
              let TPTSelO = [];
              let TPTSF = [];
              let TPTINV = [];
              //   let TCUR = [];
              let TPTRE = [];
              let TPTQUN = [];
              let INVID = [];
              let UNT = [];

              if (data.TPTMergeConInvoiceTallyData.length > 0) {
                this.TPTMergeConInvoiceTallyData =
                  data.TPTMergeConInvoiceTallyData;

                for (
                  let p = 0;
                  p < this.TPTMergeConInvoiceTallyData.length;
                  p++
                ) {
                  TPTParti =
                    this.TPTMergeConInvoiceTallyData[p].particulars.split(",");
                  INVID = this.TPTMergeConInvoiceTallyData[p].invoiceId;
                  TPTCon =
                    this.TPTMergeConInvoiceTallyData[p].containerType.split(
                      ","
                    );
                  TPTQUN =
                    this.TPTMergeConInvoiceTallyData[p].quantity.split(",");
                  UNT = this.TPTMergeConInvoiceTallyData[p].unit.split(",");
                  TPTSelO =
                    this.TPTMergeConInvoiceTallyData[p].quotationRate.split(
                      ","
                    );
                  TPTSF =
                    this.TPTMergeConInvoiceTallyData[p].sellingRateFinal.split(
                      ","
                    );
                  TPTINV =
                    this.TPTMergeConInvoiceTallyData[
                      p
                    ].finalRateWithoutTax.split(",");
                  TPTRE = this.TPTMergeConInvoiceTallyData[p].remark.split(",");
                  if (TPTParti.length > 0) {
                    TPTParti.map((z, index) => {
                      let obj2 = {
                        ffType: z,
                        containerType: TPTCon[index],
                        quantity: TPTQUN[index],
                        ffSellingRate: TPTSelO[index],
                        exchRate: 1,
                        sellingRateFinal: TPTSF[index],
                        unit: UNT[index],
                        invAmount: TPTINV[index],
                        currency: "INR",

                        remark:
                          TPTINV[index] == "Charges As Per Receipt"
                            ? "Charges As Per Receipt " + " && " + TPTRE[index]
                            : TPTRE[index],
                        mainffId: INVID,
                        slectedStatus: "0",
                        color: "1",
                      };
                      this.ffTallyInvoiceData.push(obj2);
                      //  this.tptCheckDone = 1;
                    });
                  }
                }
              }
            }
            if (data.CCMergeConInvoiceTallyData.length > 0) {
              let CCParti = [];
              let CCCon = [];
              let CCSellingR = [];
              let CCSF = [];
              let CCInvAmt = [];
              let CCCurrency = [];
              let CCQuantity = [];
              let CCRemark = [];
              let UN = [];
              let EXRTCC = [];

              if (data.CCMergeConInvoiceTallyData.length > 0) {
                console.log("CCacois");
                CCParti =
                  data.CCMergeConInvoiceTallyData[0].particulars.split(",");
                CCCon =
                  data.CCMergeConInvoiceTallyData[0].containerType.split(",");
                CCQuantity =
                  data.CCMergeConInvoiceTallyData[0].quantity.split(",");
                CCSellingR =
                  data.CCMergeConInvoiceTallyData[0].quotationRate.split(",");
                CCSF =
                  data.CCMergeConInvoiceTallyData[0].sellingRateFinal.split(
                    ","
                  );
                if (data.CCMergeConInvoiceTallyData[0].exchRate) {
                  EXRTCC =
                    data.CCMergeConInvoiceTallyData[0].exchRate.split(",");
                } else {
                  EXRTCC = [];
                }
                CCInvAmt =
                  data.CCMergeConInvoiceTallyData[0].finalRateWithoutTax.split(
                    ","
                  );
                CCCurrency =
                  data.CCMergeConInvoiceTallyData[0].currency.split(",");
                UN = data.CCMergeConInvoiceTallyData[0].unit.split(",");

                CCRemark = data.CCMergeConInvoiceTallyData[0].remark.split(",");
              } else {
                //  this.alert.content = "Charges Not Received From CC";
                //         this.$refs["addPop"].open();
              }
              if (CCParti.length > 0) {
                CCParti.map((x, index) => {
                  let obj1 = {
                    ffType: x,
                    containerType: CCCon[index],
                    quantity: CCQuantity[index],
                    ffSellingRate: CCSellingR[index],
                    exchRate: EXRTCC[index],
                    sellingRateFinal: CCSF[index],
                    unit: UN[index],
                    invAmount: CCInvAmt[index],
                    currency: CCCurrency[index],

                    remark:
                      CCInvAmt[index] == "Charges As Per Receipt"
                        ? "Charges As Per Receipt " + " && " + CCRemark[index]
                        : CCRemark[index],
                    slectedStatus: "0",
                    color: "1",
                  };

                  this.ffTallyInvoiceData.push(obj1);

                  // this.CCCheckDone = 1;
                });
              }
            }
            if (id == "1") {
              this.getData();
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {});
    },

    getData() {
      this.ffTallyInvoiceData = [];
       this.isLoading = true; 
      let type_Size = {
        itemCode: "itemCode",
        allModuleId: this.all_module_id,
        InvTallyId: this.$route.query.InvTallyId,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/getDataTallyBilling_NewV3_test.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            console.log("option");
            this.isLoading = false;

            if (data.fflastData.length > 0) {
              this.tempffTableArry = data.fflastData;
              console.log("1234ff");
            }

            if (data.enquiryData.length > 0) {
              this.enquiryData.shipmentType = data.enquiryData[0].shipmentType;
              this.enquiryData.fclOrlcl = data.enquiryData[0].containerInfo;
            }

            if (data.ccTableData.length > 0) {
              this.ccTableArry = data.ccTableData;
              console.log("1234cc");
            }

            if (data.tptTableData.length > 0) {
              this.tptTableData = data.tptTableData;
              console.log("1234tpt");
            }

            if (data.tptMain.length > 0) {
              Object.keys(data.tptMain[0]).map((x) => {
                this.tptModal[x] = data.tptMain[0][x] || "";
              });
            } else {
              this.tptModal.distance = data.distancegps;
            }

            if (data.mainExecutionDetails.length > 0) {
              this.mainExecutionDetails = data.mainExecutionDetails;
              this.shipmentType = data.mainExecutionDetails[0].shipmentType;
              if (this.$route.query.classId) {
                this.classId = this.$route.query.classId;
                this.ffInvoiceModal.jobNo =
                  data.mainExecutionDetails[0].mainSalesSeries +
                  "/" +
                  this.classId;
              } else {
                this.ffInvoiceModal.jobNo =
                  data.mainExecutionDetails[0].mainSalesSeries;
              }
              // Priyanshu Singh Start

              this.ffInvoiceModal.shippingLine =
                data.mainExecutionDetails[0].shippingLine;

              this.ffInvoiceModal.shipperInvNo =
                data.mainExecutionDetails[0].shipperInvoiceNo;

              this.ffInvoiceModal.BOE =
                data.mainExecutionDetails[0].shippingBillNo;

              this.ffInvoiceModal.LP =
                data.mainExecutionDetails[0].Load_port.replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();

              this.ffInvoiceModal.POD =
                data.mainExecutionDetails[0].port_of_discharge
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();

              this.ffInvoiceModal.POR =
                data.mainExecutionDetails[0].place_of_receipt
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();

              this.ffInvoiceModal.FPOD = data.mainExecutionDetails[0].fpod
                .replace(/\s*,\s*/g, ",")
                .replace(/\s\s+/g, " ")
                .trim();

              if (data.ffmaindetails.length > 0) {
                this.ffInvoiceModal.vessel = data.ffmaindetails[0].vessel;
                this.ffInvoiceModal.blNo = data.ffmaindetails[0].blNo;
                this.ffInvoiceModal.weight = data.ffmaindetails[0].weight;
              } else if (data.ccmaindetails.length > 0) {
                this.ffInvoiceModal.vessel = data.ccmaindetails[0].vessel;
                this.ffInvoiceModal.blNo = data.ccmaindetails[0].blNo;
                this.ffInvoiceModal.weight = data.ccmaindetails[0].weight;
              } else {
                this.ffInvoiceModal.vessel = "";
                this.ffInvoiceModal.blNo = "";
                this.ffInvoiceModal.weight = "";
              }

              this.ffInvoiceModal.Handover =
                data.mainExecutionDetails[0].handoverloc;

              this.ffInvoiceModal.pickup =
                data.mainExecutionDetails[0].pickuploc;

              this.ffInvoiceModal.factoryLoc =
                data.mainExecutionDetails[0].factoryloc;
              // Priyanshu Singh End

              this.ffInvoiceModal.sentForRevisedApproval =
                data.mainExecutionDetails[0].sentForRevisedApproval;
              this.ffInvoiceModal.revisedActionTakenFromMail =
                data.mainExecutionDetails[0].revisedActionTakenFromMail;

              if (this.mainExecutionDetails[0].clientType != "3") {
                this.ffInvoiceModal.clientName =
                  data.mainExecutionDetails[0].clientName;
                this.ffInvoiceModal.clientId =
                  data.mainExecutionDetails[0].clientId;

                this.ffInvoiceModal.acutalclientForOverSea =
                  data.mainExecutionDetails[0].exporter;
                this.ffInvoiceModal.stateName =
                  data.mainExecutionDetails[0].stateName;
                this.ffInvoiceModal.clientgst =
                  data.mainExecutionDetails[0].gstCode +
                  data.mainExecutionDetails[0].GSTN;
                this.ffInvoiceModal.contact =
                  data.mainExecutionDetails[0].kycContact;
                this.ffInvoiceModal.adress =
                  data.mainExecutionDetails[0].corporateAddress;
              }

              this.ffInvoiceModal.allModuleId =
                data.mainExecutionDetails[0].allModuleId;
              this.ffInvoiceModal.ccTypeExImp =
                data.mainExecutionDetails[0].transportType;
              this.ffInvoiceModal.shippingLine =
                data.mainExecutionDetails[0].shippingLine;
              this.ffInvoiceModal.billingLocationId =
                data.mainExecutionDetails[0].billingLocationId;
              this.getServicesData();
            }

            if (data.InvoiceData.length > 0) {
              this.ffInvoiceModal.clientName = data.InvoiceData[0].clientName;
              this.ffInvoiceModal.address = data.InvoiceData[0].address;
              this.ffInvoiceModal.contact = data.InvoiceData[0].contact;
              // console.log("Client name => ",this.ffInvoiceModal.clientName);
            }
            if (data.billingTableData.length > 0) {
              this.billingTableData = data.billingTableData;

              this.disableJobType = data.billingTableData[0].jobType;
            } else {
              this.billingTableData = [];
            }
            if (id == "1") {
              this.showMoreItem();
              Object.keys(this.ffInvoiceModal).map((x) => {
                this.ffInvoiceModal[x] = "";
              });
            }
            if (
              this.selectedTallyInv == false &&
              this.revisedSavedBillingData.length > 0
            ) {
              this.ffTallyInvoiceData = this.revisedSavedBillingData;
            }

            if (data.mainExecutionDetails.length > 0) {
              let arryNewBillBranch = this.billingLocationData.filter((x) => {
                if (x.branchLocation) {
                  return x.branchLocation
                    .split(",")
                    .includes(
                      data.mainExecutionDetails[0].addedBy_user_baseLocation
                    );
                }
                // return x.branchLocation == data.mainExecutionDetails[0].billingLocationId;
              });

              if (arryNewBillBranch.length > 0) {
                this.ffInvoiceModal.billingLocationId =
                  arryNewBillBranch[0].billingLocationId;
                this.ffInvoiceModal.billingLocationName =
                  arryNewBillBranch[0].billingLocation;
              }
            }

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
  },
  // methods: {
  //   setQuotationType(type) {
  //     this.tptTableArryType = type;
  //     this.showQuotation();
  //   },
  //   showQuotation() {
  //     // alert(this.tempffTableArry.length);
  //     if (this.tempffTableArry.length > 0) {
  //       this.tptTableArryType = "FF";
  //       this.tempffTableArry = [];
  //       this.tptTableData = [];
  //       this.ccTableArry = [];
  //     } else if (this.ccTableArry.length > 0) {
  //       this.tptTableArryType = "CC";
  //     } else {
  //       this.tptTableArryType = "TPT";
  //     }
  //     this.setShowQuotation = !this.setShowQuotation;
  //   },
  //   showQuotationMOdal() {
  //     this.showQuotationModal = !this.showQuotationModal;
  //     this.QuotationSummary();
  //   },
  //   QuotationSummary() {
  //     if (this.showQuotationModal == true && this.QT_fk_all_module_id != "") {
  //       this.$refs["QuptationSummary-modal"].show();
  //       this.getData();
  //     } else {
  //       // this.showQuotationModal =false;
  //       this.$refs["QuptationSummary-modal"].hide();
  //     }
  //   },
  //   getData() {
  //     if (this.QT_fk_all_module_id != "") {
  //       let payload = {
  //         filter: "QuotationSummary",
  //         allModuleId: this.QT_fk_all_module_id,
  //       };

  //       let options = {
  //         method: "POST",
  //         url: `${URL_BASE}/Api_Common/viewAssignmentTrackDetails.php`,
  //         data: JSON.stringify(payload),
  //         crossDomain: true,
  //         headers: {
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //           Authorization: this.$sessionsStorage.get("loginId"),
  //         },
  //       };
  //       axios(options)
  //         .then((result) => {
  //           const { statusText, status, data } = result;
  //           if (status == 200 && data) {
  //             console.log(data);
  //             this.tempffTableArry = [];
  //             this.ccTableData = [];
  //             this.tptTableData = [];
  //             this.mainExecutionDetailsData = [];
  //             // alert(data.fflastData.length);
  //             if (data.fflastData.length > 0) {
  //               this.tempffTableArry = data.fflastData;
  //             }

  //             if (data.enquiryData.length > 0) {
  //               this.enquiryData.shipmentType =
  //                 data.enquiryData[0].shipmentType;
  //               this.enquiryData.fclOrlcl = data.enquiryData[0].containerInfo;
  //             }

  //             if (data.ccTableData.length > 0) {
  //               this.ccTableArry = data.ccTableData;
  //             }

  //             if (data.tptTableData.length > 0) {
  //               this.tptTableData = data.tptTableData;
  //             }
  //             // alert(this.ccTableArry);
  //             // alert(this.tptTableData);
  //             // alert(this.tempffTableArry);
  //             console.log("this.ccTableArry=>", this.ccTableArry);
  //             console.log("this.tptTableData=>", this.tptTableData);
  //             console.log("this.tempffTableArry=>", this.tempffTableArry);

  //             if (this.tempffTableArry.length > 0) {
  //               // this.showQuotation();
  //               if (this.tempffTableArry.length > 0) {
  //                 this.tptTableArryType = "FF";
  //               } else if (this.ccTableArry.length > 0) {
  //                 this.tptTableArryType = "CC";
  //               } else {
  //                 this.tptTableArryType = "TPT";
  //               }
  //               this.setShowQuotation = !this.setShowQuotation;
  //             }

  //             if (data.mainExecutionDetailsData.length > 0) {
  //               this.mainExecutionDetailsData = data.mainExecutionDetailsData;
  //               this.shipmentType =
  //                 data.mainExecutionDetailsData[0].shipmentType;
  //               this.ffInvoiceModal.jobNo =
  //                 data.mainExecutionDetailsData[0].mainSalesSeries;

  //               // Priyanshu Singh Start

  //               // this.ffInvoiceModal.shippingLine =data.mainExecutionDetailsData[0].shippingLine;

  //               // this.ffInvoiceModal.shipperInvNo =
  //               //   data.mainExecutionDetailsData[0].shipperInvoiceNo;

  //               // this.ffInvoiceModal.BOE =
  //               //   data.mainExecutionDetailsData[0].shippingBillNo;

  //               // this.ffInvoiceModal.LP =
  //               //   data.mainExecutionDetailsData[0].Load_port.replace(
  //               //     /\s*,\s*/g,
  //               //     ","
  //               //   )
  //               //     .replace(/\s\s+/g, " ")
  //               //     .trim();

  //               // this.ffInvoiceModal.POD =
  //               //   data.mainExecutionDetailsData[0].port_of_discharge
  //               //     .replace(/\s*,\s*/g, ",")
  //               //     .replace(/\s\s+/g, " ")
  //               //     .trim();

  //               // this.ffInvoiceModal.POR =
  //               //   data.mainExecutionDetailsData[0].place_of_receipt
  //               //     .replace(/\s*,\s*/g, ",")
  //               //     .replace(/\s\s+/g, " ")
  //               //     .trim();

  //               // this.ffInvoiceModal.FPOD = data.mainExecutionDetailsData[0].fpod
  //               //   .replace(/\s*,\s*/g, ",")
  //               //   .replace(/\s\s+/g, " ")
  //               //   .trim();

  //               // if (data.ffmaindetails.length > 0) {
  //               //   this.ffInvoiceModal.vessel = data.ffmaindetails[0].vessel;
  //               //   this.ffInvoiceModal.blNo = data.ffmaindetails[0].blNo;
  //               //   this.ffInvoiceModal.weight = data.ffmaindetails[0].weight;
  //               // } else if (data.ccmaindetails.length > 0) {
  //               //   this.ffInvoiceModal.vessel = data.ccmaindetails[0].vessel;
  //               //   this.ffInvoiceModal.blNo = data.ccmaindetails[0].blNo;
  //               //   this.ffInvoiceModal.weight = data.ccmaindetails[0].weight;
  //               // } else {
  //               //   this.ffInvoiceModal.vessel = "";
  //               //   this.ffInvoiceModal.blNo = "";
  //               //   this.ffInvoiceModal.weight = "";
  //               // }

  //               // this.ffInvoiceModal.Handover =
  //               //   data.mainExecutionDetailsData[0].handoverloc;

  //               // this.ffInvoiceModal.pickup =
  //               //   data.mainExecutionDetailsData[0].pickuploc;

  //               // this.ffInvoiceModal.factoryLoc =
  //               //   data.mainExecutionDetailsData[0].factoryloc;
  //               // // Priyanshu Singh End

  //               // this.ffInvoiceModal.sentForRevisedApproval =
  //               //   data.mainExecutionDetailsData[0].sentForRevisedApproval;
  //               // this.ffInvoiceModal.revisedActionTakenFromMail =
  //               //   data.mainExecutionDetailsData[0].revisedActionTakenFromMail;

  //               // if (this.mainExecutionDetailsData[0].clientType != "3") {
  //               //   this.ffInvoiceModal.clientName =
  //               //     data.mainExecutionDetailsData[0].clientName;
  //               //   this.ffInvoiceModal.clientId =
  //               //     data.mainExecutionDetailsData[0].clientId;

  //               //   this.ffInvoiceModal.acutalclientForOverSea =
  //               //     data.mainExecutionDetailsData[0].exporter;
  //               //   this.ffInvoiceModal.stateName =
  //               //     data.mainExecutionDetailsData[0].stateName;
  //               //   this.ffInvoiceModal.clientgst =
  //               //     data.mainExecutionDetailsData[0].gstCode +
  //               //     data.mainExecutionDetailsData[0].GSTN;
  //               //   this.ffInvoiceModal.contact =
  //               //     data.mainExecutionDetailsData[0].kycContact;
  //               //   this.ffInvoiceModal.adress =
  //               //     data.mainExecutionDetailsData[0].corporateAddress;
  //               // }

  //               // this.ffInvoiceModal.allModuleId =
  //               //   data.mainExecutionDetailsData[0].allModuleId;
  //               // this.ffInvoiceModal.ccTypeExImp =
  //               //   data.mainExecutionDetailsData[0].transportType;
  //               // this.ffInvoiceModal.shippingLine =
  //               //   data.mainExecutionDetailsData[0].shippingLine;
  //               // this.ffInvoiceModal.billingLocationId =
  //               //   data.mainExecutionDetailsData[0].billingLocationId;

  //               // this.getServicesData();
  //             }
  //           }
  //         })
  //         .catch((error) => {});
  //     }
  //   },
  // },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>


// WEBPACK FOOTER //
// quotationSummary.vue?917e18d6